<template>
    <div class="dropdown-menu p-0 dpMenu" style="width: 400px;">
        <div class="cropspage__items__dropdown">
            <div class="row">
                <h4 class="font-bold font-sm margin_top_md caps_upper">Crop types</h4>
            </div>
            <!-- <Loading v-if="filteringCrops" /> -->
            <div class="row" v-if="crops">
                <div class="col-4 pr-2 pl-0" v-for="(crop, index) in crops" :key="index">
                    <label class="checkbox-inline control-label">
                        <crop-type-row :crop="crop" @cropValue="cropValue" />
                    </label>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import CropTypeRow from './CropTypeRow';

export default {
    props: ['croptypes'],
    data() {
        return {
            values: [],
            crops: [],
            gettingCrops: false,
        }
    },
    methods: {
        cropValue(value) {
            if(this.values.includes(value)) {
                const index = this.values.findIndex(item => item === value)
                this.values.splice(index, 1)
            } else {
                this.values.push(value)
            }
            this.$emit('cropTypeValues', this.values)
        },
        getCrops() {
            this.gettingCrops = true;
            this.$http.get("crops").then(({ data }) => {
                this.crops = data;
                this.$log(this.crops) 
            })
            .catch(err => {
                this.$toastr.error(err);
            })
            .finally(() => {
                this.gettingCrops = false
            })
        },

    },
    created() {
        this.getCrops();
    },
    components: {
        CropTypeRow
    }
}
</script>

<style>

</style>